<script>
  export let laender_dict;

  function select() {}

  function select_all() {
    laender_dict.forEach(function (value, i) {
      laender_dict[i]["checked"] = true;
    });
  }

  function unselect_all() {
    laender_dict.forEach(function (value, i) {
      laender_dict[i]["checked"] = false;
    });
  }
</script>

<div class="col">
  <div class="row">
    {#each laender_dict as ld}
      <div class="col" style="width:40px; padding-right:30px;">
        <div class="form-check" style="padding-left:0px; padding-right:0px;">
          <input
            class="form-check-input"
            type="checkbox"
            on:change={select}
            bind:checked={ld["checked"]}
            value=""
            id="flexCheckDefault{ld['short']}"
          />
          <label class="form-check-label" style="white-space: nowrap; font-size:12px;" for="flexCheckDefault{ld['short']}">
            {ld["short"]}
          </label>
        </div>
      </div>
    {/each}
    <!-- Platzhalter weil die Anzahl der Länder nicht immer genau in s Raster passt -->
    <div class="col" />
    <div class="col" />
    <div class="col" />
    <div class="col" />
    <div class="col" />
  </div>
</div>

<div class="row">
  <div class="col-0" />
  <div class="col-2">
    <div class="maus" style="white-space: nowrap; font-size:8px;" on:click={select_all}><u>Select all</u></div>
  </div>

  <div class="col-2">
    <div class="maus" style="white-space: nowrap; font-size:8px;" on:click={unselect_all}><u> Unselect</u></div>
  </div>

  <div class="col-7" />
</div>

<style>
  .maus:hover {
    cursor: pointer;
  }
</style>
